function SettingPage() {
  return <div className='setting-page' data-testid='setting-page'>settingPage</div>
}

export default SettingPage
